import React, { Component } from 'react';
import { any, propOr } from 'ramda';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Skeleton from 'react-loading-skeleton';
import Permission from './Permission';

const style = theme => ({
  root: {
    listStyle: 'none',
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
  },
});

class Permissions extends Component {
  renderLoading = () => (
    <div>
      {Array(10).fill(null).map((val, i) => (
        <ul key={i}>
          <Skeleton />
        </ul>
      ))}
    </div>
  )

  render() {
    const {
      template, classes, onChange, readOnly, isLoading,
    } = this.props;

    if (isLoading) {
      return this.renderLoading();
    }

    return (
      <ul className={classes.root}>
        {template.map((resource, idx) => {
          if (resource.permission) {
            return (
              <Permission
                key={idx}
                readOnly={readOnly}
                resource={resource}
                onChange={onChange}
              />
            );
          }
        })}
      </ul>
    );
  }
}

Permissions.propTypes = {
  template: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default withStyles(style)(Permissions);
